import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import RootErrorBoundary from "@/RootErrorBoundary";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Missing #root element");
}

const root = ReactDOM.createRoot(rootEl);
root.render(
  <React.StrictMode>
    <RootErrorBoundary>
      <App />
    </RootErrorBoundary>
  </React.StrictMode>,
);
